import { reactive } from "vue";

export const cabdStore = reactive({
    mapZoom: 3.4,
    setZoom(zoom) {
        this.mapZoom = zoom;
    },
    userEmail: '',
    setEmail(email) {
        this.userEmail = email;
    },
    userName: '',
    setName(name) {
        this.userName = name;
    },
    userOrg: '',
    setOrg(org) {
        this.userOrg = org;
    },
    mailList: false,
    setMail(mail) {
        this.mailList = mail;
    },
    userConsent: false,
    setConsent(consent) {
        this.userConsent = consent;
    },
});